<template>
  <div class="query-material-container">
    <Search v-bind="search" />
    <MTable v-bind="table" @search="getTableData">
      <template #picPath="{ value }">
        <el-image
          style="width: 100px; height: 100px"
          :src="value"
          :preview-src-list="[value]"
        ></el-image>
      </template>
    </MTable>
  </div>
</template>

<script>
import Search from '@/components/form/index.vue';
import MTable from '@/components/mTable/m-table.vue';
import { getMaterialList } from '@/api/material';

export default {
  name: 'MaterialList',
  components: { Search, MTable },
  data() {
    return {
      search: {
        i18nPath: 'query',
        config: {
          span: 8,
          options: [
            {
              type: 'input',
              prop: 'keyword',
              label: 'CAS/物质名称：',
              placeholder: '请输入物质名称'
            }
          ],
          operation: {
            buttons: [
              {
                text: '查询',
                type: 'primary',
                loading: false,
                handler: async ({ setLoading }) => {
                  setLoading(true);
                  await this.getTableData();
                  setLoading(false);
                }
              }
            ]
          }
        },
        model: {
          libCode: 'fda',
          keyword: ''
        },
        dataSource: {}
      },
      table: {
        loading: true,
        i18nPath: 'query',

        tableData: [],
        pagiOption: {
          offset: 1,
          limit: 10,
          total: 0,
          pagiSize: [10, 15, 20, 30, 100],
          layout: 'total, sizes, prev, pager, next, jumper'
        },
        tableColumn: [
          { label: '物质名称', width: '460px', prop: 'zhName' },
          { label: 'CAS', width: '300px', prop: 'cas' },
          { label: '英文名称', prop: 'enName' }
          // { label: '分子式', prop: 'picPath', slot: 'picPath' }
        ],
        oprateMenu: {
          label: '操作',
          width: 180,
          list: [
            {
              text: '详情',
              access: () => true,
              event: (_, data) => {
                this.$router.push({
                  name: 'MaterialDetails',
                  params: {
                    materialId: data.id
                  }
                });
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    langChangeHandler() {
      this.getTableData();
    },
    async getTableData() {
      const table = this.table;
      try {
        table.loading = true;
        const pagiOption = this.table.pagiOption;
        const model = this.search.model;
        const params = {
          libCode: model.libCode,
          keyword: model.keyword || undefined,
          offset: pagiOption.offset,
          limit: pagiOption.limit
        };
        const { data } = (await getMaterialList(params)) || {};
        if (!data) return;
        table.tableData.splice(0, Infinity, ...data.list);
        table.pagiOption = Object.assign(table.pagiOption, {
          total: data.total,
          limit: data.pageSize,
          offset: data.pageNum
        });
      } catch (error) {
        console.log(error);
      } finally {
        table.loading = false;
      }
    }
  },
  created() {
    this.getTableData();
  }
};
</script>

<style></style>
